import React from "react";
import { buildTree } from "../Utilities/treeUtils";
import TreeNode from "./TreeNode";

const TreeDropdown = ({ data }) => {
  const treeData = buildTree(data);

  return (
    <div className="border p-4 w-64">
      <h2 className="text-lg font-bold">Tree Dropdown</h2>
      {treeData.map((node, index) => (
        <TreeNode key={`${node.ItemId}-${index}`} node={node} />
      ))}
    </div>
  );
};

export default TreeDropdown;
